import { Box, Image, Text, Title } from "@mantine/core";
import image from "../assets/image.png";
import classes from "./noMatchInSection.module.css";

export default function NoMatchInSection() {
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.body}>
        <Title className={classes.title}>Тун удахгүй!</Title>
        <Text size="sm" c="dimmed">
          Одоогоор ашиглалтад ороогүй байгаа тул та түр хүлээнэ үү баярлалаа.
        </Text>
      </Box>
      <Image alt="" className={classes.image} src={image} />
    </Box>
  );
}
